export default __webpack_public_path__ + "static/media/background.5bf61f29.png";